'use strict';

import _ from 'lodash';
import React, {PropTypes} from 'react';
import { connect } from 'react-redux';

@connect((state, props) => {
  const designations = state.designations;
  const items = _.map(designations, (value) => value);

  return  {
    items,
    script: props.script
  };
})
export default class ProfessionalDesignationsSummary extends React.Component {
  static propTypes = {
    items: PropTypes.array,
    script: PropTypes.bool
  }

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className='expanded-accordion-content explanation-of-wahve'>
      <div className='callout'>If the applicant has designation, explain:</div>
        {
          this.props.script
          &&
            <div className='speaking-callout'>
              We recommend you maintain your designations as it indicates your commitment to staying current.
            </div>
        }
      <div className='summary-container'>
        <ul>
          <li className='summary-row'>Category</li>
          {
            _.map(this.props.items, item =>
              <li className='summary-row'>
                <div className='summary-row-item'>{item.name}</div>
              </li>
            )
          }
          {
            (this.props.items.length === 0)
            &&
            <li className='summary-row'>
              <div className='summary-row-item-empty'>No professional designations have been selected</div>
            </li>
          }
        </ul>
      </div>
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/applicant/ProfessionalDesignationsSummary/index.js